export default __webpack_public_path__ + "static/media/face-4.03453a44.jpg";